module.exports = __webpack_public_path__ + "static/img/3bg_10.a362a8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_10.png
// module id = 677
// module chunks = 1